/** @jsxImportSource @emotion/react */
import { Box, Heading, Text } from 'grommet'
import Image from 'next/image'
import { CSSObject } from '@emotion/react'
import ExternalAnchor from 'components/ExternalAnchor'
import { useTranslation } from 'next-i18next'

type Logo = {
  file: string
  alt: string
  href: string
  width: number
  height: number
  css?: CSSObject
}

const logos: Logo[] = [
  {
    file: 'pearson.png',
    href: 'https://pearson.com/',
    alt: 'Pearson, leading learning company',
    width: 149,
    height: 45,
  },
  {
    file: 'comcast.com.png',
    href: 'https://www.comcast.com/',
    alt: 'Comcast',
    width: 149,
    height: 45,
  },
  {
    file: 'bearingpoint.png',
    href: 'https://bearingpoint.com/',
    alt: 'BearingPoint - Consulting, Solutions and Ventures',
    width: 149,
    height: 45,
  },
  {
    file: 'accenture.png',
    href: 'https://accenture.com/',
    alt: 'Accenture',
    width: 149,
    height: 45,
  },
  // {
  //   file: 'camplight.net.png',
  //   alt: 'Camplight.net',
  //   href: 'https://camplight.net',
  //   width: 803,
  //   height: 200,
  // },
  {
    file: 'centric.eu.png',
    href: 'https://centric.eu/',
    alt: 'Centric Europe',
    width: 149,
    height: 45,
  },
  {
    file: 'd-impact.org.png',
    href: 'https://d-impact.org/',
    alt: 'Design Impact',
    width: 149,
    height: 45,
  },
  {
    file: 'deped.gov.ph1.png',
    href: 'https://deped.gov.ph/',
    alt: 'Republic of the Philippines - Department of Education',
    width: 149,
    height: 45,
  },
  {
    file: 'groundwork.org.uk.png',
    href: 'https://groundwork.org.uk/',
    alt: 'Groundwork, federation of charities',
    width: 149,
    height: 45,
  },
  { file: 'dxc.com.png', href: 'https://dxc.com/', alt: 'DXC Technology', width: 264, height: 45 },
  {
    file: 'mentormate.com.svg',
    href: 'https://mentormate.com/',
    alt: 'MentorMate, Custom Software Development Company',
    width: 149,
    height: 45,
  },
  { file: 'emag.ro.png', href: 'https://emag.ro/', alt: 'eMAG Romania', width: 149, height: 45 },
  // {
  //   file: 'canyons.edu.png',
  //   href: 'https://www.canyons.edu/',
  //   alt: 'College of the Canyons',
  //   width: 1200,
  //   height: 583,
  // },
  {
    file: 'maine.edu.png',
    href: 'https://maine.edu/',
    alt: 'University of Maine System',
    width: 149,
    height: 45,
  },
  {
    file: 'melroseschools.com.png',
    href: 'https://www.melroseschools.com/',
    alt: 'Melrose Public Schools',
    width: 149,
    height: 45,
  },
  {
    file: 'nebasecamp.org.webp',
    href: 'https://nebasecamp.org/',
    alt: 'NE Basecamp, Educational Non-Profit, New England',
    width: 149,
    height: 45,
  },
  {
    file: 'deped.gov.ph.png',
    href: 'https://deped.gov.ph/',
    alt: 'Republic of the Philippines - Department of Education',
    width: 149,
    height: 45,
  },
  // {
  //   file: 'nbcusd.org.jpg',
  //   href: 'https://nbcusd.org/',
  //   alt: 'North Boone Community Unit School District 200',
  //   width: 128,
  //   height: 150,
  //   css: { background: 'white' },
  // },
  {
    file: 'usc.edu.ph.png',
    href: 'https://usc.edu.ph/',
    alt: 'University of San Carlos, Philippines',
    width: 149,
    height: 45,
  },
  // {
  //   file: 'nayra.coop.svg',
  //   href: 'https://nayra.coop/',
  //   alt: 'Nayra - Cooperativa de desarrollo digital',
  //   width: 844,
  //   height: 187,
  //   css: { background: 'black', padding: '0 1rem' },
  // },
  {
    file: 'ada.ac.uk.svg',
    href: 'https://ada.ac.uk/',
    alt: 'Ada. National College for Digital Skills',
    width: 149,
    height: 45,
  },
  {
    file: 'vsu.edu.ph.png',
    href: 'https://vsu.edu.ph/',
    alt: 'Visayas State University, Philippines',
    width: 149,
    height: 45,
    css: { background: 'black', padding: '0 1rem' },
  },
  {
    file: 'ateneo.edu.png',
    href: 'https://ateneo.edu/',
    alt: 'Ateneo de Manila University',
    width: 149,
    height: 45,
  },
  {
    file: 'cnu.edu.ph.png',
    href: 'https://cnu.edu.ph/',
    alt: 'Cebu Normal University, Philippines',
    width: 149,
    height: 45,
  },
  //   {
  //     file: 'obf.ateneo.edu.png',
  //     href: 'https://obf.ateneo.edu/',
  //     alt: 'Ateneo de Manila University',
  //     width: 500,
  //     height: 253,
  //   },
  {
    file: 'bpsma.org.svg',
    href: 'https://bpsma.org/',
    alt: 'Brockton Public Schools',
    width: 149,
    height: 45,
  },
  {
    file: 'positiveworkplaces.org.png',
    href: 'https://positiveworkplaces.org/',
    alt: 'Positive Workplaces',
    width: 149,
    height: 45,
  },
  {
    file: 'sbtech.com.png',
    href: 'https://www.sbtech.com/',
    alt: 'SBTech',
    width: 149,
    height: 45,
  },
  {
    file: 'progress.com.png',
    href: 'https://progress.com/',
    alt: 'Progress',
    width: 149,
    height: 45,
  },
]

export default function LogoBox({ number = logos.length }) {
  const { t } = useTranslation()
  return (
    <Box>
      <Heading level={3} fill textAlign="center">
        {t('components.logo-box.trusted-by')}
      </Heading>
      <Box margin="large" align="center" justify="center" direction="row" wrap>
        {logos.slice(0, number).map((logo, key) => (
          <Box
            key={key}
            margin="large"
            width="149px"
            height="45px"
            align="center"
            justify="center"
            css={{ ...logo.css }}>
            <ExternalAnchor href={logo.href}>
              <Image
                objectFit="contain"
                src={`/teams-using-moodlight/${logo.file}`}
                alt={logo.alt}
                title={logo.alt}
                width={logo.width}
                height={logo.height}
              />
            </ExternalAnchor>
          </Box>
        ))}
      </Box>

      <Text size="small" color="#333" textAlign="center">
        {t('components.logo-box.contact-us-list')}
      </Text>
    </Box>
  )
}
